// extracted by mini-css-extract-plugin
export default {"multiSelect":"MultiSelectOption_multiSelect__+LA9B"};